export default {
  breadcrumb: {
    settlements: "Settlements  >",
    settlementId: "Settlement {id}"
  },
  title: "Settlement",
  createdAt: "Settlement created at",
  totalAmount: "Total amount",
  sponsor: "Sponsor: ",
  loadingDataLabel: "Loading claims",
  emptyDataLabel: "No results found",
  resultLabel: "{result} Claim | {result} Claims",
  NoResults: "No claims found",
  attachedDocuments: 'Attached documents | {count} Attached document | {count} Attached documents',
  grid: {
    authorizationId: "ID",
    createdAt: "Created At",
    beneficiary: "Beneficiary",
    memberCode: "Member Code",
    coverage: "Coverage", 
    branch: "Branch",
    amount: "Amount"
  },
  filters: {
    searchCode: "Search by claim ID"
  },
  reasonRejection: "Reason for rejection",
  manualAuthorizations: {
    tittle: "Manual Authorization",
    quantity: "Quantity",
    amount: "Amount"
  }
}
